<div class="flex flex-row bg-slate-100 rounded-l shadow rounded">
    <a href="{{ profileUrl }}" class="grow">
        <div class="flex flex-row p-2 gap-2 group hover:cursor-pointer hover:bg-ponder-linkhover hover:bg-opacity-15 text-sm">
            <div class="flex flex-row items-center gap-2 grow">
                <div class="w-10 h-10 sm:w-12 sm:h-12 bg-center bg-no-repeat rounded-full magic-card-shadow" style="background-size: cover; background-image: url('{{ avatarUrl }}');">
        
                </div>
                <div class="flex flex-col">
                    <div class="font-bold">
                        {{ displayName }}
                    </div>
                    <div class="text-slate-400">
                        {{ username }}
                    </div>
                </div>
            </div>
        </div>
    </a>
    @if (isProcessing) {
        <div class="flex items-center bg-slate-300 shadow p-4">
            <busy-spin></busy-spin>
        </div>
    } @else {
        @if (waiting) {
            <button (click)="onAcceptClick()" class="flex items-center bg-green-300 shadow p-4 group hover:bg-green-500 hover:cursor-pointer">
                <svg class="w-6 h-6 fill-none stroke-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke-width="1">
                    <title>Accept Friend</title>
                    <path stroke-linecap="round" stroke-linejoin="round" [attr.d]="acceptIconSvg" />
                </svg>
            </button>
        }                           
        <button (click)="onDeleteClick()" class="flex items-center bg-red-300 rounded-r shadow p-4 group hover:bg-red-500 hover:cursor-pointer">
            <svg class="w-6 h-6 fill-none stroke-white" xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke-width="1">
                <title>Delete Friend</title>
                <path stroke-linecap="round" stroke-linejoin="round" [attr.d]="deleteIconSvg" />
            </svg>
        </button>
    }
</div>
<ng-template #confirmationModalTemplate></ng-template>